// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Container,
  Paper,
  Tooltip,
  InputBase,
  IconButton,
  ListItem,
  List,
  ListItemText,
  Checkbox,
} from "@mui/material";
import "reactjs-popup/dist/index.css";
// import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
// import usePoolsPageContext from "../../context/usePoolsPageContext.js";
import { useHistory } from "react-router-dom";
import {
  BodyLarge,
  BodyMedium,
  H7TitleLarge,
} from "../components/StyledComponents/Typography/Typography.tsx";

import {
  PrimaryButton,
  SecondaryButton,
} from "../components/StyledComponents/Buttons/AuradineButtons.js";

import SearchIcon from "@mui/icons-material/Search";
import ActionDialog from "../components/ActionDialog/ActionDialog.js";
import SiteAndGroupTree from "../minerstatusV2/Components/LeftPanel/SiteAndGroupTree/SiteAndGroupTree.js";
import useAppContextProvider from "../AppContext/useAppContextProvider.js";
import { flatMap, set, stubObject } from "lodash";
import AddAddressDialog from "./Components/AddSitesAndGroupsDialog/AddAddressDialog.js";
import AddSitesAndGroupsDialog from "./Components/AddSitesAndGroupsDialog/AddSitesAndGroupsDialog.js";
import { StyledCheckbox } from "../components/StyledComponents/Inputs/Inputs.js";
import { useGetSiteLists } from "../api/queries/useGetSiteLists.ts";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { useAuth0 } from "@auth0/auth0-react";
import { GetAllSitesList } from "../api/api.js";
import { SiteAndGroupTreeContextProvider } from "../minerstatusV2/context/SiteAndGroupTreeContext.js";
import { useDeleteSiteOrGroup } from "./queries/useDeleteSiteOrGroup.ts";
import OperationLogsDialog from "../components/OperationsLogsDialog/OperationLogsDialog.js";
import { GetUserUseQuery } from "../api/api.js";
import { useQuery } from "@tanstack/react-query";
import AuradineErrorState from "../components/StyledComponents/EmptyStates/AuradineErrorState.tsx";
import PageWrapper from "../components/PageWrapper/PageWrapper.js";
import { useTheme } from "../ThemeContext/ThemeContext.js";

export const HeaderContainer = React.memo((props) => {
  const { data } = props;

  const history = useHistory();

  return (
    <Box
      className={"header-container"}
      display={"flex"}
      justifyContent="space-between"
      flexDirection="column"
      gap={4}
      marginBottom={"1.5rem"}
    >
      <Box
        className={"title-box"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={3.5}
      >
        <H7TitleLarge>{`Site & Group Management`}</H7TitleLarge>
        <BodyLarge>
          Add, delete, and view sites and groups with their
          associated miner counts.
        </BodyLarge>
      </Box>
    </Box>
  );
});

const WhiteListsPageHeader = (props) => {
  const {
    onSitesAndGroupSearch,
    siteAndGroups,
    setSiteAndGroups,
    searchValue,
    setSearchValue,
    handleDeletionForSitesAndGroups,
    setOpenAddSitesAndGroupsDialog,
    setOpenAddAddressDialog,
    role,
    siteLists,
  } = props;
  const { colors } = useTheme();
  const handleDialogOpen = () => {
    setOpenAddSitesAndGroupsDialog(true);
  };
  const handleAddressDialogOpen = () => {
    setOpenAddAddressDialog(true);
  };
  console.log("siteAndGroups in header", siteLists);
  return (
    <Box
      display={"grid"}
      justifyContent={"space-between"}
      gridTemplateColumns={"1fr 1fr"}
    >
      <Box display={"grid"} gridTemplateColumns={"2fr 1fr"}>
        {siteLists &&
          siteLists.status === "ok" &&
          Array.isArray(siteLists.siteList) &&
          siteLists.siteList.length > 0 && (
            <Paper
              component="form"
              elevation={0}
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: colors?.background?.secondary,  
                borderRadius: "1.75rem",
                paddingLeft: "1rem",
              }}
            >
              <Tooltip
                // title={searchValue}
                disableFocusListener
                disableTouchListener
              >
                <InputBase
                  sx={{ flex: 1, minWidth: "22.5rem", color: colors?.text?.primary }}
                  placeholder="Search by site or group name"
                  onChange={(event) => {
                    setSearchValue(event.target.value);
                    onSitesAndGroupSearch(event);
                  }}
                  inputProps={{
                    "aria-label": "search google maps",
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                    }
                  }}
                />
              </Tooltip>
              <IconButton
                type="button"
                sx={{ p: "10px" }}
                aria-label="search"
              >
                <SearchIcon sx={{ color: colors?.text?.muted }} />
              </IconButton>
            </Paper>
          )}
      </Box>
      <Box
        display={"flex"}
        flexDirection={"row"}
        gap={2}
        justifyContent={"flex-end"}
        alignItems={"center"}
      >
        <SecondaryButton colors={colors}
          onClick={handleDeletionForSitesAndGroups}
          disabled={
            (Array.isArray(siteAndGroups) &&
              siteAndGroups.length > 0 &&
              !siteAndGroups.some(
                (siteInfo) =>
                  (siteInfo.selectedSite &&
                    siteInfo.deviceCount === 0) ||
                  siteInfo.groups.some(
                    (groupInfo) =>
                      groupInfo.selectedGroup &&
                      groupInfo.deviceCount === 0
                  )
              )) ||
            role === "user" ||
            siteAndGroups.length === 0
          }
        >
          Delete
        </SecondaryButton>
        <SecondaryButton colors={colors}
          disabled={
            (Array.isArray(siteAndGroups) &&
              (siteAndGroups.filter(siteInfo => siteInfo.selectedSite).length > 1 ||
               siteAndGroups.filter(siteInfo => siteInfo.selectedSite).length === 0)) ||
            role === "user" ||
            siteAndGroups.length === 0
          }
          onClick={handleAddressDialogOpen}
        >
          Update Location
        </SecondaryButton>
        <PrimaryButton colors={colors}
          disabled={
            role === "user" || siteAndGroups.length === 0
          }
          onClick={handleDialogOpen}
        >
          Add
        </PrimaryButton>
      </Box>
    </Box>
  );
};

/**
 * Represents the MinerPage component.
 * This component displays a table of miner devices and provides functionality to interact with them.
 */
function SitesAndGroupsManagementContent() {
  const { colors } = useTheme();
  const {
    setToastOpen,
    setToastMessage,
    setOperationLogs,
    openOperationLogsDialog,
    setOpenOperationLogsDialog,
  } = useAppContextProvider();
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const tableContainerRef = React.useRef(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [authToken, setAuthToken] = useState("");
  const [deletionDialogOpen, setDeletionDialogOpen] =
    useState(false);
  const [
    openAddSitesAndGroupsDialog,
    setOpenAddSitesAndGroupsDialog,
  ] = useState(false);
  const [
    openAddAddressDialog,
    setOpenAddAddressDialog,
  ] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [siteAndGroups, setSiteAndGroups] = React.useState(
    []
  );

  useEffect(() => {
    const fetchToken = async () => {
      try {
        if (!isAuthenticated) {
          setAuthToken("");
          console.warn(
            "User is not authenticated. Fetching token..."
          );
          return;
        }
        const token = await getAccessTokenSilently({
          cacheMode: "cache-only",
          ignoreCache: true,
        });
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
    const interval = setInterval(() => {
      fetchToken();
    }, 5 * 60 * 1000); // Refresh every 15 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, [getAccessTokenSilently, isAuthenticated]);

  const {
    data: siteLists,
    isLoading: isSiteGroupDataLoading,
    isFetching: isSiteGroupDataFetching,
    isFetched: isSiteGroupDataFetched,
    refetch,
  } = useGetSiteLists(
    { authToken },
    {
      notifyOnChangeProps: "all",
    }
  );

  const {
    data: userInfo,
    isFetched: isUserInfoFetched,
    isFetching: isUserInfoFetching,
  } = useQuery({
    queryKey: ["userInfo"],
    queryFn: () => GetUserUseQuery(authToken),
    enabled: !!authToken,
  });
  const userRole = userInfo?.user?.role;

  useEffect(() => {
    if (siteLists) {
      if (
        siteLists?.status === "ok" &&
        siteLists?.siteList?.length > 0
      ) {
        const siteList = siteLists?.siteList.map((site) => {
          // Find existing selection state for this site
          const existingSite = siteAndGroups.find(existing => existing.siteName === site.siteName);

          return {
            ...site,
            selectedSite: existingSite?.selectedSite || false,
            groups: site.groups.map((group) => {
              // Find existing selection state for this group
              const existingGroup = existingSite?.groups?.find(existing => existing.DGName === group.DGName);

              return {
                ...group,
                selectedGroup: existingGroup?.selectedGroup || false,
              };
            }),
          };
        });
        setSiteAndGroups(siteList);
      }
    }
  }, [siteLists, isSiteGroupDataFetching]);

  const [numberOfSelections, setNumberOfSelections] =
    useState(0);

  const onSitesAndGroupSearch = (e) => {
    if (e.target.value === "") {
      setSiteAndGroups(siteLists?.siteList);
      return;
    } else {
      const sitesData = [...siteLists?.siteList];
      const foundSite = sitesData && sitesData.filter((site) => {
        return (
          site?.siteName
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          (site.groups &&
            site.groups.some((group) =>
              group.DGName.toLowerCase().includes(
                e.target.value.toLowerCase()
              )
            ))
        );
      });

      setSiteAndGroups(foundSite);
    }
  };

  const onDeletionClick = () => {
    setDeletionDialogOpen(true);
  };

  const { mutate: deleteSiteOrGroup } =
    useDeleteSiteOrGroup();

  const handleDeletion = () => {
    const siteAndGroupInfoCopy = [...siteAndGroups];

    const filteredData = siteAndGroupInfoCopy
      .map((site) => {
        if (site.selectedSite) {
          return site;
        }
        if (
          site.groups.length > 0 &&
          !site.selectedSite &&
          site.groups.some((group) => group.selectedGroup)
        ) {
          const selectedGroups = site.groups.filter(
            (group) => group.selectedGroup
          );
          return { ...site, groups: selectedGroups };
        }
        return null;
      })
      .filter((site) => site !== null);
    console.log("fiteredDataAfterDeletion", filteredData);
    deleteSiteOrGroup(
      {
        siteAndGroupList: filteredData,
      },
      {
        onSuccess: async (data) => {
          if (data.status === "ok") {
            setToastOpen(true);
            setToastMessage(
              "Sites and groups deletion completed. Please check operation logs for details."
            );
            setOperationLogs(data.logs);
            setOpenOperationLogsDialog(true);
            setNumberOfSelections(0);
            await refetch();
          } else {
            setToastOpen(true);
            setToastMessage(
              "Failed to delete sites and groups," +
                data.msg
            );
          }
        },
        onError: (error) => {
          console.error(
            "Error deleting sites and groups:",
            error
          );
          setToastOpen(true);
          setToastMessage(
            "Failed to delete sites and groups"
          );
        },
      }
    );
    setDeletionDialogOpen(false);
  };

  const DeletionList = () => {
    const [deletionList, setDeletionList] = useState([]);
    useEffect(() => {
      const deletionList = flatMap(
        siteAndGroups,
        (siteGroupInfo) => {
          if (siteGroupInfo.selectedSite) {
            return siteGroupInfo.groups.length > 0
              ? siteGroupInfo.groups.map(
                  (groupInfo) =>
                    `/${siteGroupInfo.siteName}/${groupInfo.DGName}`
                )
              : `/${siteGroupInfo.siteName}/`;
          } else {
            return siteGroupInfo.groups
              .filter(
                (groupInfo) => groupInfo.selectedGroup
              )
              .map(
                (groupInfo) =>
                  `/${siteGroupInfo.siteName}/${groupInfo.DGName}`
              );
          }
        }
      ).filter(Boolean); // Filter out empty strings
      setDeletionList(deletionList);
    }, [siteAndGroups]);

    return (
      <List sx={{ maxHeight: "12rem", overflowY: "auto" }}>
        {deletionList.map((itemToBeDeleted, index) => (
          <ListItem
            button={false}
            key={index}
            sx={{ borderBottom: "1px solid " + colors?.border?.default }}
          >
            <ListItemText>
              <BodyLarge>{itemToBeDeleted}</BodyLarge>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    );
  };

  const handleParentCheckboxSelection = (event) => {
    if (event.target.checked) {
      const siteGroupsCopy = [...siteAndGroups];
      setNumberOfSelections(0);
      const siteGroupsCopyAllTrue = siteGroupsCopy.map(
        (siteAndGroup) => {
          let selectionCount = 0;
          siteAndGroup.selectedSite = true;
          selectionCount += 1;
          if (siteAndGroup.groups.length > 0) {
            siteAndGroup.groups = [
              ...siteAndGroup.groups,
            ].map((group) => {
              group.selectedGroup = true;
              selectionCount += 1;
              return group;
            });
          }
          setNumberOfSelections(
            (prev) => prev + selectionCount
          );
          return siteAndGroup;
        }
      );

      setSiteAndGroups(siteGroupsCopyAllTrue);
    } else {
      const siteGroupsCopy = [...siteAndGroups];
      const siteGroupsCopyAllFalse = siteAndGroups.map(
        (siteAndGroup) => {
          siteAndGroup.selectedSite = false;
          setNumberOfSelections((prev) => prev - 1);
          if (siteAndGroup.groups.length > 0) {
            siteAndGroup.groups = [
              ...siteAndGroup.groups,
            ].map((group) => {
              group.selectedGroup = false;
              setNumberOfSelections((prev) => prev - 1);
              return group;
            });
          }
          return siteAndGroup;
        }
      );
      setSiteAndGroups(siteGroupsCopyAllFalse);
    }
  };

  return (
    <PageWrapper>
      <HeaderContainer />
      <Grid
        container
        className={"miner-page-table-container"}
        display={"flex"}
        flexDirection={"row"}
        spacing={4}
        sx={{ transition: "all 0.3s ease-in-out" }}
      >
        <Grid
          ref={tableContainerRef}
          item
          xs={12}
          sx={{
            transition: "width 0.3s ease-in-out", // Smooth transition for width
          }}
        >
          <Box
            className={"miner-page-table"}
            display={"flex"}
            flexDirection={"row"}
            backgroundColor={colors.background.paper}
            padding={"0.75rem 0  0.75rem 0"}
            borderRadius={"1rem"}
            sx={{
              transition: "width 0.3s ease-in-out", // Smooth transition for width
            }}
          >
            <Box
              className={"table-container"}
              display={"flex"}
              flexDirection={"column"}
              padding={"0 0.75rem 0 0.75rem"}
              height={"auto"}
              minWidth={"0"}
              gap={4}
              flex={3}
              flexShrink={1}
            >
              <WhiteListsPageHeader
                onSitesAndGroupSearch={
                  onSitesAndGroupSearch
                }
                siteAndGroups={siteAndGroups}
                setSiteAndGroups={setSiteAndGroups}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                handleDeletionForSitesAndGroups={
                  onDeletionClick
                }
                setOpenAddSitesAndGroupsDialog={
                  setOpenAddSitesAndGroupsDialog
                }
                setOpenAddAddressDialog={
                  setOpenAddAddressDialog
                }
                role={userRole}
                siteLists={siteLists}
              />
              <Box
                className={"Datagrid-container"}
                display={"flex"}
                flexDirection={"column"}
                flexShrink={1}
                flexGrow={1}
                // overflowY={"auto"}
                height="calc(100vh - 17rem)"
              >
                {siteAndGroups.length > 0 && (
                  <Box
                    display="grid"
                    gridTemplateColumns={"2rem auto"}
                    justifySelf={"start"}
                    alignItems={"center"}
                    columnGap={2}
                    marginLeft={"1.30rem"}
                  >
                    <StyledCheckbox
                      colors={colors}
                      onChange={(e) =>
                        handleParentCheckboxSelection(e)
                      }
                      indeterminate={
                        numberOfSelections > 0 &&
                        numberOfSelections <
                          siteAndGroups.length +
                            siteAndGroups.reduce(
                              (acc, site) =>
                                acc + site.groups.length,
                              0
                            )
                      }
                      checked={
                        numberOfSelections !== 0 &&
                        numberOfSelections ===
                          siteAndGroups.length +
                            siteAndGroups.reduce(
                              (acc, site) =>
                                acc + site.groups.length,
                              0
                            )
                      }
                    />
                    <BodyMedium>{`${numberOfSelections} items selected`}</BodyMedium>
                  </Box>
                )}
                {isSiteGroupDataFetched &&
                  (!isSiteGroupDataFetching ||
                    !isSiteGroupDataLoading) &&
                  siteLists &&
                  siteLists.status === "ok" &&
                  Array.isArray(siteLists.siteList) &&
                  siteLists.siteList.length === 0 && (
                    <AuradineErrorState
                      message={`You do not have permission to access any sites. Please contact your superadmin`}
                    />
                  )}
                {isSiteGroupDataFetched &&
                  (!isSiteGroupDataFetching ||
                    !isSiteGroupDataLoading) &&
                  siteLists &&
                  siteLists.status !== "ok" && (
                    <AuradineErrorState
                      message={` ${siteLists?.msg}`}
                    />
                  )}
                <SiteAndGroupTree
                  siteAndGroups={siteAndGroups}
                  setSiteAndGroups={setSiteAndGroups}
                  onSitesAndGroupSearch={
                    onSitesAndGroupSearch
                  }
                  clickDisabled={true}
                  multiSelectModel={true}
                  maxHeight={"calc(100vh - 19rem)"}
                  setNumberOfSelections={
                    setNumberOfSelections
                  }
                  numberOfSelections={numberOfSelections}
                  isSiteGroupDataLoading={
                    isSiteGroupDataLoading
                  }
                  isSiteGroupDataFetching={
                    isSiteGroupDataFetching
                  }
                  isSiteGroupDataFetched={
                    isSiteGroupDataFetched
                  }
                  searchValue={searchValue}
                />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <OperationLogsDialog
        open={openOperationLogsDialog}
        setOpen={setOpenOperationLogsDialog}
      />
      <AddSitesAndGroupsDialog
        open={openAddSitesAndGroupsDialog}
        setOpen={setOpenAddSitesAndGroupsDialog}
        sitesAndGroupInfo={siteAndGroups}
        setSiteAndGroups={setSiteAndGroups}
        refetch={refetch}
        role={userRole}
        siteLists={siteLists?.siteList}
      />
      <AddAddressDialog
        open={openAddAddressDialog}
        setOpen={setOpenAddAddressDialog}
        sitesAndGroupInfo={siteAndGroups}
        setSiteAndGroups={setSiteAndGroups}
        refetch={refetch}
        role={userRole}
        siteLists={siteLists?.siteList}
      />
      <ActionDialog
        open={deletionDialogOpen}
        onClose={() => setDeletionDialogOpen(false)}
        headerMessage={"Delete these sites or groups?"}
        subMessage={
          "Deleting the site or group removes it from FluxVision. This action cannot be undone."
        }
        buttonText={"Delete"}
        deleteAction={handleDeletion}
        extraInfo={true}
        ExtraInfoComponent={DeletionList}
      />
    </PageWrapper>
  );
}

export default function SitesAndGroupsManagementPage() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
      },
      mutations: {
        retry: 0,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <SiteAndGroupTreeContextProvider>
        <SitesAndGroupsManagementContent />
      </SiteAndGroupTreeContextProvider>
    </QueryClientProvider>
  );
}